.gi{border:1px solid #ddd;}